// Arabisch (ar), food: zelfde vorm als food.nl.ts. Korte zinnen; op de kiosk eenvoudige woorden.
export const foodAr = {
    nav: 'الطعام',
    title: 'الطعام',
    tabs: {
        shopping: 'المشتريات',
        recipes: 'الوصفات',
        menu: 'قائمة طعام الأسبوع',
        pantry: 'المخزون',
    },
    undo: 'تراجع',
    save: 'حفظ',
    cancel: 'إلغاء',
    close: 'إغلاق',
    remove: 'حذف',
    retry: 'حاول مرة أخرى',
    errorLoad: 'لم ينجح التحميل. حاول مرة أخرى.',
    errorSave: 'لم ينجح الحفظ. حاول مرة أخرى.',
    categories: {
        produce: 'خضار وفاكهة',
        bakery: 'خبز وفطور',
        dairy: 'ألبان وبيض',
        meat: 'لحوم وأسماك',
        pantry: 'خزانة المؤن',
        drinks: 'مشروبات',
        household: 'أدوات المنزل',
        other: 'أخرى',
    },
    units: {
        g: 'غرام',
        kg: 'كيلو',
        ml: 'مل',
        cl: 'سل',
        dl: 'دل',
        l: 'لتر',
        el: 'ملعقة كبيرة',
        tl: 'ملعقة صغيرة',
        kop: 'كوب',
        snuf: 'رشة',
        stuk: 'حبة',
        teen: 'فص',
        blik: 'علبة معدنية',
        pak: 'عبوة',
        zak: 'كيس',
        bos: 'حزمة',
        plak: 'شريحة',
        fles: 'زجاجة',
        doos: 'صندوق',
        krop: 'رأس',
        pot: 'مرطبان',
        takje: 'غصن',
        handje: 'حفنة',
        scheut: 'دفقة',
    },
    shopping: {
        addLabel: 'ماذا نحتاج؟',
        addPlaceholder: 'مثلًا: 2 عبوة حليب',
        add: 'أضف',
        frequent: 'نشتريه كثيرًا',
        inBasket: 'في سلتك ({count})',
        clearChecked: 'امسح المشطوب',
        newList: 'قائمة',
        newListTitle: 'قائمة جديدة',
        listName: 'اسم القائمة',
        listNameHint: 'مثلًا: السوق أو الصيدلية',
        listsLabel: 'قوائم المشتريات',
        renameList: 'تعديل القائمة',
        archiveList: 'حذف القائمة',
        listMenu: 'المزيد لهذه القائمة',
        archiveAsk: 'حذف قائمة {name}؟',
        archiveHint: 'ما فيها يُحذف معها. يمكنك التراجع فورًا.',
        archivedList: 'حُذفت قائمة {name}',
        lastList: 'لا يمكن حذف آخر قائمة. غيّر اسمها بدلًا من ذلك.',
        emptyTitle: 'كل شيء في البيت',
        emptyBody: 'أضف هنا ما تحتاجونه؛ يراه الجميع فورًا.',
        added: 'أُضيف {name}',
        merged: '{name}: الآن {amount}',
        removed: 'حُذف {name}',
        cleared: 'مُسحت المشتريات المشطوبة',
        viaTablet: 'من الجهاز اللوحي',
        forRecipe: 'من أجل {title}',
        editItem: 'تعديل الغرض',
        name: 'الاسم',
        amount: 'الكمية',
        unit: 'الوحدة',
        noUnit: 'بلا',
        note: 'ملاحظة',
        icon: 'الرمز',
        list: 'القائمة',
        check: 'شطب {name}',
        uncheck: 'إرجاع {name}',
        addedBy: 'أضافه: {name}',
    },
    recipes: {
        search: 'ابحث عن وصفة',
        filterAll: 'الكل',
        filterOwn: 'وصفاتنا',
        filterLibrary: 'المجموعة',
        add: 'وصفة',
        newTitle: 'وصفة جديدة',
        editTitle: 'تعديل الوصفة',
        modeManual: 'أكتبها بنفسي',
        modeLink: 'من رابط',
        link: 'رابط الوصفة',
        linkHint: 'يعمل مع مواقع الوصفات ومع YouTube وTikTok وInstagram.',
        fetch: 'جلب',
        fetching: 'جارٍ جلب الوصفة…',
        name: 'اسم الوصفة',
        description: 'وصف قصير',
        servings: 'الأشخاص',
        minutes: 'الدقائق',
        ingredients: 'المكونات',
        ingredientsHint: 'مكوّن في كل سطر، مثلًا: 500 غ لحم مفروم',
        steps: 'طريقة التحضير',
        stepsHint: 'خطوة في كل سطر',
        minutesShort: '{n} د',
        people: 'أشخاص: {n}',
        video: 'فيديو',
        needsIngredients: 'أضف المكونات',
        noResults: 'لم نجد وصفة',
        noResultsBody: 'جرّب كلمة أخرى أو أضف وصفة بنفسك.',
        emptyTitle: 'لا وصفات بعد',
        emptyBody: 'أضف أول وصفة لك، أو اجلبها من رابط.',
        toMenu: 'إلى قائمة الطعام',
        toList: 'إلى المشتريات',
        edit: 'تعديل',
        photo: 'إضافة صورة',
        changePhoto: 'صورة أخرى',
        removePhoto: 'إزالة الصورة',
        photoUploading: 'جارٍ رفع الصورة…',
        photoTooLarge: 'هذه الصورة كبيرة جدًا.',
        photoUnsupported: 'هذا الملف ليس صورة يمكننا استخدامها.',
        archive: 'إخفاء',
        archived: 'أُخفيت {title}',
        openVideo: 'شاهد الفيديو',
        openSource: 'إلى الموقع',
        back: 'كل الوصفات',
        fromLibrary: 'من المجموعة',
        ingredientsEmpty: 'لا مكونات بعد.',
        stepsEmpty: 'لا طريقة تحضير بعد.',
        toListTitle: 'إلى قائمة المشتريات',
        toListBody: 'ما هو في المخزون أو موجود دائمًا في البيت غير محدد.',
        toListDo: 'أضف إلى القائمة',
        toListDone: '{count} في {list}',
        toListMerged: '{count} في {list}، دُمج {merged}',
        toListNothing: 'كل شيء في القائمة أو موجود في البيت.',
        staple: 'موجود دائمًا',
        inPantry: 'في البيت',
        pickDayTitle: 'أضف إلى قائمة الطعام',
        pickDay: 'اختر يومًا',
        planned: '{title} يوم {day}',
        created: 'أُضيفت {title}',
        imported: 'جُلبت {title}',
        importErrors: {
            no_recipe_found: 'لا توجد في هذه الصفحة وصفة يمكننا قراءتها. هل تكتبها بنفسك؟',
            blocked_address: 'لا يمكننا فتح هذا الرابط.',
            invalid_url: 'استخدم رابطًا آمنًا (يبدأ بـ https).',
            too_large: 'هذه الصفحة كبيرة جدًا للقراءة.',
            timeout: 'لم يستجب الموقع في الوقت المناسب. حاول لاحقًا.',
            fetch_failed: 'لا يمكن الوصول إلى الموقع الآن.',
        },
        fillManually: 'أكتبها بنفسي',
    },
    menu: {
        week: 'الأسبوع {week}',
        range: '{from} – {to}',
        thisWeek: 'هذا الأسبوع',
        prev: 'الأسبوع السابق',
        next: 'الأسبوع القادم',
        allToList: 'الكل إلى المشتريات',
        choose: 'اختر',
        chooseFor: 'اختر ما نأكله يوم {day}',
        dragHint: 'اسحب وصفة إلى يوم',
        tapHint: 'اضغط على + اختر عند يوم',
        moreRecipes: 'وصفات أخرى ({count})',
        freeSection: 'أو شيء آخر، مثلًا: الأكل في مطعم',
        freeSave: 'إلى قائمة الطعام',
        pickRecipe: 'اختر وصفة',
        shelf: 'الوصفات',
        removeMeal: 'إزالة {title} من قائمة الطعام',
        removed: 'أُزيلت {title} من قائمة الطعام',
        moved: 'نُقلت إلى {day}',
        freeText: 'أو اكتب شيئًا آخر',
        freePlaceholder: 'مثلًا: الأكل في مطعم',
        emptyTitle: 'لا شيء في قائمة الطعام بعد',
        emptyBody: 'اسحب وصفة إلى يوم.',
        today: 'اليوم',
        nothingToList: 'لا توجد وصفات في قائمة طعام هذا الأسبوع بعد.',
        servings: 'أشخاص: {n}',
    },
    pantry: {
        addLabel: 'ماذا لدينا في البيت؟',
        addPlaceholder: 'مثلًا: 1 كيلو بطاطا',
        add: 'أضف',
        listLabel: 'في المخزون',
        removeItem: 'إخراج {name} من المخزون',
        removed: 'أُخرج {name} من المخزون',
        suggestionsTitle: 'ماذا يمكننا أن نطبخ؟',
        allInHouse: 'كل شيء في البيت',
        stillNeeded: 'ما زلنا نحتاج: {items}',
        emptyTitle: 'لا شيء في المخزون بعد',
        emptyBody: 'أضف ما لديك، ونقترح عليك ما يمكنك طبخه.',
        noSuggestions: 'لا توجد بعد وصفة لديكم كل مكوناتها.',
        staples: 'الملح والفلفل والزيت والماء موجودة دائمًا في البيت.',
    },
    kiosk: {
        entry: 'الطعام',
        back: 'رجوع',
        tonight: 'عشاؤنا الليلة',
        nothingPlanned: 'لم نخطط شيئًا بعد',
        nothingPlannedBody: 'بابا أو ماما يختار في التطبيق.',
        tomorrow: 'غدًا',
        add: 'أضف',
        addTitle: 'ماذا نحتاج؟',
        close: 'إغلاق',
        added: 'أُضيف {name}',
        oops: 'تراجع',
        emptyTitle: 'كل شيء في البيت',
        check: '{name}: في السلة؟',
        // UX-ronde bord: een regel in het mandje met één tik terugzetten.
        backOnList: '{name}: أعِده إلى القائمة',
        confirm: 'في السلة',
        shopping: 'المشتريات',
        week: 'هذا الأسبوع',
        inBasket: '{name} في السلة',
        more: 'مشتريات أخرى',
        alreadyOn: '{name} موجود في القائمة',
        typeOwn: 'اكتب بنفسك',
        typeLabel: 'ماذا نحتاج؟',
        typePlaceholder: 'مثلًا: حليب',
        typeAdd: 'أضف',
        closeTyping: 'العودة إلى الصور',
        moreTiles: 'صور أخرى',
    },
};
//# sourceMappingURL=food.ar.js.map